import React from "react";
import { Typography, Box, Tooltip, IconButton, Button } from "@mui/material";
import { useAuditoria } from "../contexts/AuditoriaContext";
import { useAuditoriaUtils } from "../hooks/useAuditoriaUtils";
import { Add, CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";

export default function PeriodosAuditoriaView() {
  const {
    auditingOdontologo,
    auditingPaciente,
    auditoriaActivaFecha,
    modoAuditoria,
    periodoCerrado,
  } = useAuditoria();
  const { handleNuevoPeriodo, handleActivarPeriodo, handleAbrirCerrarPeriodo } =
    useAuditoriaUtils();
  return (
    <Box display="flex" gap={2} flexWrap="wrap">
      <Button
        onClick={handleNuevoPeriodo}
        variant="contained"
        color="primary"
        sx={{ width: 200 }}
        startIcon={<Add />}
      >
        Agregar período
      </Button>
      <Button
        onClick={() => !modoAuditoria && handleActivarPeriodo()}
        variant="contained"
        color="primary"
        disabled={modoAuditoria || periodoCerrado}
        sx={{ width: 200 }}
        startIcon={<CheckCircle />}
      >
        Activar período
      </Button>
      <Button
        onClick={handleAbrirCerrarPeriodo}
        variant="contained"
        color="primary"
        sx={{ width: 200 }}
        startIcon={
          <i
            className={`fa-solid ${
              !periodoCerrado ? "fa-lock" : "fa-lock-open"
            }`}
            style={{ fontSize: "1rem" }} // más pequeño que fa-sm
          />
        }
      >
        {periodoCerrado ? "Abrir período" : "Cerrar período"}
      </Button>
    </Box>
  );
}
